import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id E3745997-1AD2-4D79-83FE-72ADE96E3C69
 * name image-filter-center-focus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-center-focus.svg
 * tags
 * - Photography 
 */
export const ImageFilterCenterFocusIcon = createSvgIcon(<><path d="M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9M19,19H15V21H19A2,2 0 0,0 21,19V15H19M19,3H15V5H19V9H21V5A2,2 0 0,0 19,3M5,5H9V3H5A2,2 0 0,0 3,5V9H5M5,15H3V19A2,2 0 0,0 5,21H9V19H5V15Z" /></>, 'ImageFilterCenterFocusIcon');
export default ImageFilterCenterFocusIcon